// @flow

import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { colors } from '../style'

const items = [
  {
    slug: 'book',
    path: '/'
  },
  {
    slug: 'bio',
    path: '/bio'
  },
  {
    slug: 'comments',
    path: '/comments'
  },
  {
    slug: 'archive',
    path: '/archive'
  }
]

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto 30px auto;
  max-width: 960px;

  border-bottom: 2px solid ${colors.red};
`

const BaseNavLink = styled.a`
  padding: 3px 15px;

  text-decoration: none;
  white-space: nowrap;

  font-family: sans-serif;

  color: black;

  &:last-child {
    padding-right: 0;
  }
  &:first-child {
    padding-left: 0;
  }

  &:hover {
    color: ${colors.red};
  }
`

const NavLink = styled(({className, ...props}) => <BaseNavLink {...props} activeClassName={className} />)`
  font-weight: bold;

  color: ${colors.red};
`

function Nav() {
  return (
    <Root>
      {items.map((item, index) => (
        <NavLink href={item.path} key={index}>
          <FormattedMessage id={`nav.${item.slug}`} />
        </NavLink>
      ))}
      <NavLink href="/en">
        English
      </NavLink>
    </Root>
  )
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav.js